import { render } from "./AdminUsuarios.vue?vue&type=template&id=53b9e738&scoped=true"
import script from "./AdminUsuarios.vue?vue&type=script&lang=js"
export * from "./AdminUsuarios.vue?vue&type=script&lang=js"

import "./AdminUsuarios.vue?vue&type=style&index=0&id=53b9e738&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53b9e738"]])

export default __exports__